import { render, staticRenderFns } from "./AcessoNegado.vue?vue&type=template&id=6f45be7b"
import script from "./AcessoNegado.vue?vue&type=script&lang=js"
export * from "./AcessoNegado.vue?vue&type=script&lang=js"
import style0 from "./AcessoNegado.vue?vue&type=style&index=0&id=6f45be7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports